import { render, staticRenderFns } from "./EmployeeDetailsComponent.vue?vue&type=template&id=424dae7c&scoped=true&"
import script from "./EmployeeDetailsComponent.vue?vue&type=script&lang=js&"
export * from "./EmployeeDetailsComponent.vue?vue&type=script&lang=js&"
import style0 from "./EmployeeDetailsComponent.vue?vue&type=style&index=0&id=424dae7c&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "424dae7c",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VAvatar } from 'vuetify/lib/components/VAvatar';
import { VCol } from 'vuetify/lib/components/VGrid';
import { VDivider } from 'vuetify/lib/components/VDivider';
import { VImg } from 'vuetify/lib/components/VImg';
import { VRow } from 'vuetify/lib/components/VGrid';
import { VSimpleTable } from 'vuetify/lib/components/VDataTable';
installComponents(component, {VAvatar,VCol,VDivider,VImg,VRow,VSimpleTable})
